import gsap from "gsap";

// Ensure stores are available before admin panel init (load order vs require.context).
require("../feedback-section/feedback-section");
require("../contacts-content/contacts-content");
require("../home-content/home-content");
require("../portfolio-content/portfolio-content");
require("../about-content/about-content");
require("../map-content/map-content");
require("../categories-content/categories-content");
require("../services-content/services-content");
require("../articles-content/articles-content");
require("../reviews-content/reviews-content");
require("./admin-map-content");
require("./admin-categories-content");
require("./admin-services-content");
require("./admin-articles-content");
require("./admin-reviews-content");
require("../faq-content/faq-content");
require("./admin-faq-content");
require("../feedback-content/feedback-content");
require("./admin-feedback-content");
require("../docs-content/docs-content");
require("./admin-docs-content");

const AUTH_KEY = "nm_admin_auth";
const AUTH_USER = "nm_admin_user";
const REDIRECT_KEY = "nm_admin_redirect";
const WELCOME_HOLD_MS = 1600;
const DEFAULT_CREDENTIALS = {
  login: "admin",
  password: "admin",
};

const ROUTES = {
  dashboard: "/admin",
  users: "/users",
  requests: "/requests",
  content: "/content",
  reviews: "/reviews",
  docs: "/docs",
  map: "/map",
  profile: "/profile",
};

const PAGE_TITLES = {
  dashboard: "Главная",
  users: "Пользователи",
  requests: "Заявки",
  content: "Контент",
  reviews: "Отзывы",
  docs: "Документация",
  map: "Карта",
  profile: "Профиль",
};

const STATUS_LABELS = {
  active: "Активен",
  pending: "Ожидает",
};

const FULL_ACCESS = "*";

const DEFAULT_PERMISSION_CATALOG = [
  { key: "dashboard", label: "Главная", system: true },
  { key: "users", label: "Пользователи", system: true },
  { key: "requests", label: "Заявки", system: true },
  { key: "content", label: "Контент", system: true },
  { key: "reviews", label: "Отзывы", system: true },
  { key: "docs", label: "Документация", system: true },
  { key: "map", label: "Карта", system: true },
];

const DEFAULT_EMPLOYEES = [
  {
    id: "1",
    name: "Admin",
    login: "admin",
    role: "Администратор",
    status: "active",
    email: "admin@newmarka.ru",
    phone: "+7 (8412) 23 47 97",
    department: "Руководство",
    note: "Полный доступ к админ-панели",
    permissions: [FULL_ACCESS],
  },
  {
    id: "2",
    name: "Мария Котова",
    login: "m.kotova",
    role: "Редактор контента",
    status: "active",
    email: "m.kotova@newmarka.ru",
    phone: "+7 (8412) 23 47 98",
    department: "Маркетинг",
    note: "Отвечает за статьи и новости",
    permissions: ["dashboard", "content", "reviews", "docs"],
  },
  {
    id: "3",
    name: "Игорь Семёнов",
    login: "i.semenov",
    role: "Менеджер портфолио",
    status: "pending",
    email: "i.semenov@newmarka.ru",
    phone: "+7 (8412) 23 47 99",
    department: "Производство",
    note: "Ожидает подтверждения доступа",
    permissions: ["dashboard", "content"],
  },
];

const adminRoot = document.querySelector("[data-admin-root]");
const loginStage = document.querySelector('[data-admin-stage="login"]');
const welcomeStage = document.querySelector('[data-admin-stage="welcome"]');
const panelStage = document.querySelector('[data-admin-stage="panel"]');
const form = document.querySelector("[data-admin-form]");
const formError = document.querySelector("[data-admin-form-error]");
const userRoot = document.querySelector("[data-admin-user]");
const userToggle = document.querySelector("[data-admin-user-toggle]");
const userMenu = document.querySelector("[data-admin-user-menu]");
const sidebar = document.querySelector("[data-admin-sidebar]");
const sidebarToggle = document.querySelector("[data-admin-sidebar-toggle]");
const sidebarOverlay = document.querySelector("[data-admin-sidebar-overlay]");
const logoutButtons = document.querySelectorAll("[data-admin-logout]");
const navLinks = document.querySelectorAll("[data-admin-link]");
const views = document.querySelectorAll("[data-admin-view]");
const pageTitle = document.querySelector("[data-admin-page-title]");
const employeesTable = document.querySelector("[data-employees-table]");
const employeesSearch = document.querySelector("[data-employees-search]");
const employeesSearchClear = document.querySelector("[data-employees-search-clear]");
const employeesCount = document.querySelector("[data-employees-count]");
const employeesFilters = document.querySelectorAll("[data-employees-filter]");
const createEmployeeBtn = document.querySelector("[data-employee-create]");
const employeeFormModal = document.querySelector('[data-employee-modal="form"]');
const employeeDetailsModal = document.querySelector('[data-employee-modal="details"]');
const employeeForm = document.querySelector("[data-employee-form]");
const employeeFormTitle = document.querySelector("[data-employee-form-title]");
const employeeDetails = document.querySelector("[data-employee-details]");
const employeePermissionsRoot = document.querySelector("[data-employee-permissions]");
const employeePermissionsAll = document.querySelector("[data-employee-permissions-all]");
const editFromDetailsBtn = document.querySelector("[data-employee-edit-from-details]");
const deleteFromDetailsBtn = document.querySelector("[data-employee-delete-from-details]");
const profileAccountForm = document.querySelector("[data-profile-account-form]");
const profileAccountNote = document.querySelector("[data-profile-account-note]");
const profileRows = document.querySelectorAll("[data-profile-row]");

let isAnimating = false;
let editingEmployeeId = null;
let detailsEmployeeId = null;
let employeesStatusFilter = "all";

if (!adminRoot) {
  document.body.classList.remove("is-admin-panel");
}

function isAuthenticated() {
  return sessionStorage.getItem(AUTH_KEY) === "1";
}

function setAuthenticated(login) {
  sessionStorage.setItem(AUTH_KEY, "1");
  sessionStorage.setItem(AUTH_USER, login);
}

function clearAuth() {
  sessionStorage.removeItem(AUTH_KEY);
  sessionStorage.removeItem(AUTH_USER);
}

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return ROUTES.dashboard;
  return pathname.replace(/\/+$/, "") || ROUTES.dashboard;
}

function getRouteFromPath(pathname = window.location.pathname) {
  const path = normalizePath(pathname);
  const matched = Object.entries(ROUTES).find(([, routePath]) => routePath === path);
  return matched ? matched[0] : "dashboard";
}

function getPathByRoute(route) {
  return ROUTES[route] || ROUTES.dashboard;
}

function closeUserMenu() {
  if (!userMenu || !userToggle) return;
  userMenu.hidden = true;
  userToggle.setAttribute("aria-expanded", "false");
}

function isMobileAdminLayout() {
  return window.matchMedia("(max-width: 1023px)").matches;
}

function closeAdminSidebar() {
  document.body.classList.remove("is-admin-sidebar-open");
  if (sidebarOverlay) sidebarOverlay.hidden = true;
  if (sidebarToggle) {
    sidebarToggle.setAttribute("aria-expanded", "false");
    sidebarToggle.setAttribute("aria-label", "Открыть меню");
  }
}

function openAdminSidebar() {
  if (!isMobileAdminLayout() || !sidebar) return;
  document.body.classList.add("is-admin-sidebar-open");
  if (sidebarOverlay) sidebarOverlay.hidden = false;
  if (sidebarToggle) {
    sidebarToggle.setAttribute("aria-expanded", "true");
    sidebarToggle.setAttribute("aria-label", "Закрыть меню");
  }
  closeUserMenu();
}

function toggleAdminSidebar() {
  if (document.body.classList.contains("is-admin-sidebar-open")) {
    closeAdminSidebar();
    return;
  }
  openAdminSidebar();
}

function setPanelMode(enabled) {
  document.body.classList.toggle("is-admin-panel", enabled);
  if (!enabled) closeAdminSidebar();
}

function toggleUserMenu() {
  if (!userMenu || !userToggle) return;
  const willOpen = userMenu.hidden;
  userMenu.hidden = !willOpen;
  userToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
  if (willOpen) closeAdminSidebar();
}

function updateNavigation(route) {
  navLinks.forEach((link) => {
    const linkRoute = link.getAttribute("data-admin-link");
    const isActive = linkRoute === route && link.classList.contains("admin-panel__nav-btn");
    link.classList.toggle("is-active", isActive);
  });

  if (pageTitle) {
    pageTitle.textContent = PAGE_TITLES[route] || PAGE_TITLES.dashboard;
  }

  applyNavigationPermissions(); // eslint-disable-line no-use-before-define
}

function showView(route) {
  const requested = ROUTES[route] ? route : "dashboard";
  const safeRoute = canAccessRoute(requested) // eslint-disable-line no-use-before-define
    ? requested
    : getFallbackRoute(); // eslint-disable-line no-use-before-define

  views.forEach((view) => {
    const node = view;
    node.hidden = node.getAttribute("data-admin-view") !== safeRoute;
  });

  updateNavigation(safeRoute);
  closeUserMenu();
  closeAdminSidebar();
  renderCurrentUserProfile(); // eslint-disable-line no-use-before-define

  if (safeRoute === "users") {
    renderEmployeesTable(); // eslint-disable-line no-use-before-define
  }

  if (safeRoute === "requests") {
    renderRequestsTable(); // eslint-disable-line no-use-before-define
  }

  if (safeRoute === "profile") {
    fillProfileAccountForm(); // eslint-disable-line no-use-before-define
  }

  if (safeRoute === "map") {
    window.NMAdminMapContent?.ensureMapReady?.();
    document.dispatchEvent(new CustomEvent("nm:admin-view", { detail: { route: "map" } }));
  }

  if (safeRoute === "reviews") {
    window.NMAdminReviewsContent?.renderReviewsAdmin?.();
    document.dispatchEvent(new CustomEvent("nm:admin-view", { detail: { route: "reviews" } }));
  }

  if (safeRoute === "docs") {
    window.NMAdminDocsContent?.renderDocsAdmin?.();
    document.dispatchEvent(new CustomEvent("nm:admin-view", { detail: { route: "docs" } }));
  }

  if (safeRoute !== requested) {
    const nextPath = getPathByRoute(safeRoute);
    window.history.replaceState({ route: safeRoute }, "", nextPath);
  }
}

function navigate(route, { replace = false } = {}) {
  const requested = ROUTES[route] ? route : "dashboard";
  const safeRoute = canAccessRoute(requested) // eslint-disable-line no-use-before-define
    ? requested
    : getFallbackRoute(); // eslint-disable-line no-use-before-define
  const nextPath = getPathByRoute(safeRoute);
  const currentPath = normalizePath(window.location.pathname);

  if (currentPath !== nextPath) {
    if (replace) {
      window.history.replaceState({ route: safeRoute }, "", nextPath);
    } else {
      window.history.pushState({ route: safeRoute }, "", nextPath);
    }
  }

  showView(safeRoute);
}

function showStage(stage) {
  [loginStage, welcomeStage, panelStage].forEach((element) => {
    if (!element) return;
    const node = element;
    node.hidden = node !== stage;
    gsap.set(node, { clearProps: "all" });
  });

  setPanelMode(stage === panelStage);
  closeUserMenu();
  closeEmployeeModals(); // eslint-disable-line no-use-before-define
}

function clearFieldErrors() {
  document.querySelectorAll("[data-admin-field]").forEach((field) => {
    field.classList.remove("has-error");
    const error = field.querySelector("[data-admin-error]");
    if (error) {
      error.hidden = true;
    }
  });

  if (formError) {
    formError.hidden = true;
  }
}

function showFieldError(name, message) {
  const field = document.querySelector(`[data-admin-field="${name}"]`);
  if (!field) return;

  field.classList.add("has-error");
  const error = field.querySelector("[data-admin-error]");
  if (error) {
    error.textContent = message;
    error.hidden = false;
  }
}

function rememberRedirect(route) {
  if (route && route !== "dashboard") {
    sessionStorage.setItem(REDIRECT_KEY, route);
  } else {
    sessionStorage.removeItem(REDIRECT_KEY);
  }
}

function consumeRedirect() {
  const saved = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return ROUTES[saved] ? saved : "dashboard";
}

function openPanel(route = "dashboard") {
  showStage(panelStage);
  navigate(route, { replace: true });
}

function animateWelcomeSequence(targetRoute = "dashboard") {
  if (!loginStage || !welcomeStage || !panelStage || isAnimating) return;

  isAnimating = true;
  setPanelMode(false);
  renderCurrentUserProfile(); // eslint-disable-line no-use-before-define

  const timeline = gsap.timeline({
    defaults: { ease: "power2.out" },
    onComplete: () => {
      isAnimating = false;
    },
  });

  timeline
    .to(loginStage, {
      opacity: 0,
      y: -24,
      duration: 0.45,
      onComplete: () => {
        loginStage.hidden = true;
        gsap.set(loginStage, { clearProps: "all" });
        welcomeStage.hidden = false;
        gsap.set(welcomeStage, { opacity: 0, y: 28, scale: 0.98 });
      },
    })
    .to(welcomeStage, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.65,
    })
    .to(welcomeStage, {
      opacity: 0,
      y: -20,
      scale: 0.98,
      duration: 0.45,
      delay: WELCOME_HOLD_MS / 1000,
      onComplete: () => {
        welcomeStage.hidden = true;
        gsap.set(welcomeStage, { clearProps: "all" });
        panelStage.hidden = false;
        setPanelMode(true);
        navigate(targetRoute, { replace: true });
        gsap.set(panelStage, { opacity: 0, y: 32 });
      },
    })
    .to(panelStage, {
      opacity: 1,
      y: 0,
      duration: 0.7,
    });
}

function handleSubmit(event) {
  event.preventDefault();
  if (isAnimating) return;

  clearFieldErrors();

  const formData = new FormData(form);
  const login = String(formData.get("login") || "").trim();
  const password = String(formData.get("password") || "");

  let hasError = false;

  if (!login) {
    showFieldError("login", "Введите логин");
    hasError = true;
  }

  if (!password) {
    showFieldError("password", "Введите пароль");
    hasError = true;
  }

  if (hasError) return;

  const api = window.NMApi;
  if (!api?.login) {
    if (formError) formError.hidden = false;
    return;
  }

  api.login(login, password).then((user) => {
    setAuthenticated(user.login);
    form.reset();
    renderEmployeesTable(); // eslint-disable-line no-use-before-define
    renderRequestsTable(); // eslint-disable-line no-use-before-define
    renderCurrentUserProfile(); // eslint-disable-line no-use-before-define
    animateWelcomeSequence(consumeRedirect());
  }).catch(() => {
    if (formError) formError.hidden = false;
  });
}

function handleLogout() {
  if (isAnimating) return;
  window.NMApi?.logout?.();
  clearAuth();
  showStage(loginStage);
  window.history.replaceState({}, "", ROUTES.dashboard);
}

function handleAdminLinkClick(event) {
  const link = event.currentTarget;
  const route = link.getAttribute("data-admin-link");
  if (!route || !ROUTES[route]) return;

  event.preventDefault();
  if (!isAuthenticated()) return;
  navigate(route);
}

function getCredentials() {
  const user = window.NMApi?.user;
  if (user) {
    return { login: user.login, password: "" };
  }
  return {
    login: String(sessionStorage.getItem(AUTH_USER) || DEFAULT_CREDENTIALS.login),
    password: "",
  };
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function getPermissionCatalog() {
  return DEFAULT_PERMISSION_CATALOG.map((item) => ({ ...item }));
}

function normalizePermissions(list) {
  if (!Array.isArray(list)) return [];
  const unique = [...new Set(list.map((item) => String(item || "").trim()).filter(Boolean))];
  if (unique.includes(FULL_ACCESS)) return [FULL_ACCESS];
  const allowed = new Set(getPermissionCatalog().map((item) => item.key));
  return unique.filter((key) => allowed.has(key));
}

function normalizeEmployee(employee = {}, index = 0) {
  let { permissions } = employee;
  if (!Array.isArray(permissions)) {
    const login = String(employee.login || "").trim().toLowerCase();
    permissions = login === "admin" ? [FULL_ACCESS] : ["dashboard"];
  }

  return {
    id: String(employee.id || `${Date.now()}-${index}`),
    name: String(employee.name || "").trim(),
    login: String(employee.login || "").trim(),
    role: String(employee.role || "").trim(),
    status: employee.status === "pending" ? "pending" : "active",
    email: String(employee.email || "").trim(),
    phone: String(employee.phone || "").trim(),
    department: String(employee.department || "").trim(),
    note: String(employee.note || "").trim(),
    permissions: normalizePermissions(permissions),
  };
}

function getEmployees() {
  const cached = window.NMApi?.cache?.users;
  if (Array.isArray(cached)) {
    return cached.map((item, index) => normalizeEmployee(item, index));
  }
  return DEFAULT_EMPLOYEES.map((item) => normalizeEmployee(item));
}

function saveEmployees(employees) {
  const payload = employees.map((item, index) => {
    const normalized = normalizeEmployee(item, index);
    const password = String(item.password || "").trim();
    return password ? { ...normalized, password } : normalized;
  });
  const forCache = payload.map((item) => {
    const copy = { ...item };
    delete copy.password;
    return copy;
  });
  if (window.NMApi) {
    window.NMApi.cache.users = forCache;
    window.NMApi.save("users", payload).catch((error) => {
      window.alert(error.message || "Не удалось сохранить пользователей"); // eslint-disable-line no-alert
    });
  }
}

function hasFullAccess(permissions) {
  return Array.isArray(permissions) && permissions.includes(FULL_ACCESS);
}

function employeeHasPermission(employee, permissionKey) {
  if (!permissionKey || permissionKey === "profile") return true;
  const permissions = normalizePermissions(employee?.permissions);
  if (hasFullAccess(permissions)) return true;
  return permissions.includes(permissionKey);
}

function canAccessRoute(route) {
  if (!route || route === "profile") return true;
  if (!ROUTES[route]) return false;
  return employeeHasPermission(getCurrentEmployee(), route); // eslint-disable-line no-use-before-define
}

function getFallbackRoute() {
  const preferred = ["dashboard", "content", "reviews", "docs", "requests", "users", "profile"];
  return preferred.find((route) => canAccessRoute(route)) || "profile";
}

function applyNavigationPermissions() {
  const employee = getCurrentEmployee(); // eslint-disable-line no-use-before-define
  navLinks.forEach((link) => {
    const route = link.getAttribute("data-admin-link");
    if (!route || !link.classList.contains("admin-panel__nav-btn")) return;
    const allowed = employeeHasPermission(employee, route);
    const node = link;
    node.hidden = !allowed;
  });
}

function formatPermissionsLabel(employee) {
  const permissions = normalizePermissions(employee?.permissions);
  if (hasFullAccess(permissions)) return "Полный доступ";
  if (!permissions.length) return "Нет прав";

  const catalog = getPermissionCatalog();
  const labels = permissions
    .map((key) => catalog.find((item) => item.key === key)?.label || key)
    .filter(Boolean);

  if (labels.length <= 2) return labels.join(", ");
  return `${labels.slice(0, 2).join(", ")} +${labels.length - 2}`;
}

function renderPermissionChips(employee) {
  const permissions = normalizePermissions(employee?.permissions);
  if (hasFullAccess(permissions)) {
    return '<span class="admin-panel__permission-chip admin-panel__permission-chip_full">Полный доступ</span>';
  }
  if (!permissions.length) {
    return '<span class="admin-panel__permission-chip admin-panel__permission-chip_empty">Нет прав</span>';
  }

  const catalog = getPermissionCatalog();
  return `
    <div class="admin-panel__permission-chips">
      ${permissions.map((key) => {
    const label = catalog.find((item) => item.key === key)?.label || key;
    return `<span class="admin-panel__permission-chip">${escapeHtml(label)}</span>`;
  }).join("")}
    </div>
  `;
}

function renderEmployeePermissionsForm(selected = []) {
  if (!employeePermissionsRoot) return;

  const catalog = getPermissionCatalog();
  const normalized = normalizePermissions(selected);
  const isFull = hasFullAccess(normalized);
  const selectedSet = new Set(normalized);

  if (employeePermissionsAll) {
    employeePermissionsAll.checked = isFull;
  }

  employeePermissionsRoot.innerHTML = catalog.map((item) => `
    <label class="admin-panel__checkbox p3" for="employee-permission-${escapeHtml(item.key)}">
      <input
        id="employee-permission-${escapeHtml(item.key)}"
        type="checkbox"
        name="permissions"
        value="${escapeHtml(item.key)}"
        data-employee-permission="${escapeHtml(item.key)}"
        ${isFull || selectedSet.has(item.key) ? "checked" : ""}
        ${isFull ? "disabled" : ""}
      />
      ${escapeHtml(item.label)}
    </label>
  `).join("");
}

function getSelectedEmployeePermissions() {
  if (employeePermissionsAll?.checked) return [FULL_ACCESS];
  if (!employeePermissionsRoot) return [];
  return [...employeePermissionsRoot.querySelectorAll("[data-employee-permission]:checked")]
    .map((input) => input.value);
}

function syncEmployeePermissionsDisabledState() {
  const isFull = Boolean(employeePermissionsAll?.checked);
  employeePermissionsRoot?.querySelectorAll("[data-employee-permission]").forEach((input) => {
    const node = input;
    node.disabled = isFull;
    if (isFull) node.checked = true;
  });
}

function getCurrentEmployee() {
  const login = String(sessionStorage.getItem(AUTH_USER) || "").trim().toLowerCase();
  const employees = getEmployees();
  const byLogin = employees.find((item) => String(item.login || "").toLowerCase() === login);
  if (byLogin) return byLogin;

  const apiUser = window.NMApi?.user;
  if (apiUser && String(apiUser.login || "").toLowerCase() === login) {
    return normalizeEmployee(apiUser);
  }

  return {
    name: login || "Пользователь",
    login: login || "",
    role: "",
    email: "",
    phone: "",
    department: "",
    note: "",
    permissions: ["dashboard"],
  };
}

function renderCurrentUserProfile() {
  const employee = getCurrentEmployee();
  const credentials = getCredentials();
  const name = employee.name || "Admin";
  const role = employee.role || "Администратор";

  document.querySelectorAll("[data-current-user-name]").forEach((node) => {
    const el = node;
    el.textContent = name;
  });

  document.querySelectorAll("[data-current-user-role]").forEach((node) => {
    const el = node;
    el.textContent = role;
  });

  const fields = {
    name,
    login: credentials.login || employee.login || "admin",
    phone: employee.phone || "—",
    department: employee.department || "—",
    password: "••••••••",
    role,
    note: employee.note || "Полный доступ к админ-панели",
  };

  Object.entries(fields).forEach(([key, value]) => {
    document.querySelectorAll(`[data-profile-field="${key}"]`).forEach((node) => {
      const el = node;
      el.textContent = value;
    });
  });
}

function getProfileRow(name) {
  return document.querySelector(`[data-profile-row="${name}"]`);
}

function clearProfileRowError(row) {
  if (!row) return;
  row.classList.remove("has-error");
  const error = row.querySelector("[data-profile-account-error]");
  if (error) error.hidden = true;
}

function showProfileRowError(row, message) {
  if (!row) return;
  row.classList.add("has-error");
  const error = row.querySelector("[data-profile-account-error]");
  if (error) {
    error.textContent = message;
    error.hidden = false;
  }
}

function closeAllProfileRows() {
  profileRows.forEach((row) => {
    const view = row.querySelector("[data-profile-row-view]");
    const edit = row.querySelector("[data-profile-row-edit]");
    if (view) view.hidden = false;
    if (edit) edit.hidden = true;
    row.classList.remove("is-editing");
    clearProfileRowError(row);

    row.querySelectorAll("input").forEach((input) => {
      const node = input;
      node.value = "";
    });
  });

  if (profileAccountNote) profileAccountNote.hidden = true;
}

function openProfileRow(name) {
  const row = getProfileRow(name);
  if (!row) return;

  closeAllProfileRows();

  const view = row.querySelector("[data-profile-row-view]");
  const edit = row.querySelector("[data-profile-row-edit]");
  const employee = getCurrentEmployee();
  const credentials = getCredentials();

  if (view) view.hidden = true;
  if (edit) edit.hidden = false;
  row.classList.add("is-editing");

  const values = {
    name: employee.name || "",
    login: credentials.login || employee.login || "",
    phone: employee.phone || "",
  };

  if (name !== "password") {
    const input = row.querySelector(`[data-profile-input="${name}"]`);
    if (input) {
      input.value = values[name] || "";
      input.focus();
      input.select();
    }
  } else {
    const first = row.querySelector('[data-profile-input="currentPassword"]');
    if (first) first.focus();
  }

  const confirm = row.querySelector(`[data-profile-confirm="${name}"]`);
  if (confirm) confirm.hidden = name !== "login";
}

function fillProfileAccountForm() {
  closeAllProfileRows();
  renderCurrentUserProfile();
}

function upsertCurrentEmployee(patch) {
  const employees = getEmployees();
  const credentials = getCredentials();
  const currentLogin = String(sessionStorage.getItem(AUTH_USER) || credentials.login || "")
    .trim()
    .toLowerCase();

  const index = employees.findIndex((item) => String(item.login || "").toLowerCase() === currentLogin);

  if (index >= 0) {
    const next = [...employees];
    next[index] = { ...next[index], ...patch };
    saveEmployees(next);
    return next[index];
  }

  const created = {
    id: String(Date.now()),
    name: patch.name || "Admin",
    login: patch.login || credentials.login || "admin",
    role: "Администратор",
    status: "active",
    email: "",
    phone: patch.phone || "",
    department: patch.department || "",
    note: "Полный доступ к админ-панели",
    permissions: [FULL_ACCESS],
    ...patch,
  };

  saveEmployees([...employees, created]);
  return created;
}

function showProfileSavedNote() {
  if (!profileAccountNote) return;
  profileAccountNote.hidden = false;
  window.setTimeout(() => {
    if (profileAccountNote) profileAccountNote.hidden = true;
  }, 2200);
}

function saveProfileField(name) {
  const row = getProfileRow(name);
  if (!row) return;

  clearProfileRowError(row);
  const credentials = getCredentials();

  if (name === "password") {
    const currentPassword = String(row.querySelector('[data-profile-input="currentPassword"]')?.value || "");
    const newPassword = String(row.querySelector('[data-profile-input="newPassword"]')?.value || "");
    const confirmPassword = String(row.querySelector('[data-profile-input="confirmPassword"]')?.value || "");

    if (!currentPassword) {
      showProfileRowError(row, "Введите текущий пароль");
      return;
    }
    if (!newPassword) {
      showProfileRowError(row, "Введите новый пароль");
      return;
    }
    if (newPassword.length < 4) {
      showProfileRowError(row, "Пароль не короче 4 символов");
      return;
    }
    if (newPassword !== confirmPassword) {
      showProfileRowError(row, "Пароли не совпадают");
      return;
    }

    window.NMApi.updateProfile({
      currentPassword,
      password: newPassword,
    }).then(() => {
      closeAllProfileRows();
      renderCurrentUserProfile();
      showProfileSavedNote();
    }).catch((error) => {
      showProfileRowError(row, error.message || "Не удалось сменить пароль");
    });
    return;
  }

  const input = row.querySelector(`[data-profile-input="${name}"]`);
  const value = String(input?.value || "").trim();

  if ((name === "name" || name === "login") && !value) {
    showProfileRowError(row, name === "name" ? "Введите имя" : "Введите логин");
    return;
  }

  if (name === "login") {
    const confirmInput = row.querySelector('[data-profile-confirm-input="login"]');
    const currentPassword = String(confirmInput?.value || "");

    if (!currentPassword) {
      showProfileRowError(row, "Введите текущий пароль");
      return;
    }

    const loginTaken = getEmployees().some((item) => {
      const itemLogin = String(item.login || "").toLowerCase();
      const currentLogin = String(credentials.login || "").toLowerCase();
      return itemLogin === value.toLowerCase() && itemLogin !== currentLogin;
    });

    if (loginTaken) {
      showProfileRowError(row, "Такой логин уже занят");
      return;
    }

    window.NMApi.updateProfile({
      login: value,
      currentPassword,
    }).then((user) => {
      upsertCurrentEmployee({ login: value });
      setAuthenticated(user.login);
      closeAllProfileRows();
      renderCurrentUserProfile();
      showProfileSavedNote();
    }).catch((error) => {
      showProfileRowError(row, error.message || "Не удалось сменить логин");
    });
    return;
  }

  if (name === "name") {
    upsertCurrentEmployee({ name: value });
  } else if (name === "phone") {
    upsertCurrentEmployee({ phone: value });
  }

  closeAllProfileRows();
  renderCurrentUserProfile();
  showProfileSavedNote();
}

function getStatusBadge(status) {
  const isActive = status === "active";
  const className = isActive ? "admin-panel__badge" : "admin-panel__badge admin-panel__badge_muted";
  return `<span class="${className}">${STATUS_LABELS[status] || status}</span>`;
}

function getEmployeesSearchQuery() {
  return String(employeesSearch?.value || "")
    .trim()
    .toLowerCase();
}

function updateSearchClearVisibility() {
  if (!employeesSearchClear) return;
  employeesSearchClear.hidden = !String(employeesSearch?.value || "").trim();
}

function updateEmployeesCount(visibleCount, totalCount) {
  if (!employeesCount) return;

  const query = getEmployeesSearchQuery();
  const hasFilter = employeesStatusFilter !== "all" || Boolean(query);

  if (!totalCount) {
    employeesCount.textContent = "Сотрудников пока нет";
    return;
  }

  if (!hasFilter) {
    employeesCount.textContent = `Всего сотрудников: ${totalCount}`;
    return;
  }

  employeesCount.textContent = `Показано: ${visibleCount} из ${totalCount}`;
}

function filterEmployees(employees) {
  const query = getEmployeesSearchQuery();

  return employees.filter((employee) => {
    if (employeesStatusFilter !== "all" && employee.status !== employeesStatusFilter) {
      return false;
    }

    if (!query) return true;

    const haystack = [
      employee.name,
      employee.login,
      employee.role,
      employee.status,
      STATUS_LABELS[employee.status],
      employee.email,
      employee.phone,
      employee.department,
      employee.note,
      formatPermissionsLabel(employee),
      ...(Array.isArray(employee.permissions) ? employee.permissions : []),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(query);
  });
}

function getRequestStatusLabel(status) {
  if (status === "in_progress") return "В работе";
  if (status === "closed") return "Закрыта";
  return "Новая";
}

function getRequestStatusClass(status) {
  if (status === "new") return "admin-panel__badge";
  return "admin-panel__badge admin-panel__badge_muted";
}

function renderRequestsTable() {
  const table = document.querySelector("[data-requests-table]");
  const count = document.querySelector("[data-requests-count]");
  if (!table) return;

  const store = window.NMSiteRequests;
  const requests = store ? store.getRequests() : [];

  if (count) {
    count.textContent = requests.length
      ? `Заявок: ${requests.length}`
      : "Заявок пока нет";
  }

  if (!requests.length) {
    table.innerHTML = `
      <tr>
        <td colspan="6">Пока нет заявок с сайта</td>
      </tr>
    `;
    return;
  }

  table.innerHTML = requests.map((request) => `
    <tr>
      <td>${escapeHtml(request.date || "—")}</td>
      <td>${escapeHtml(request.name || "—")}</td>
      <td>${escapeHtml(request.contact || "—")}</td>
      <td>${escapeHtml(request.source || "Форма обратной связи")}</td>
      <td><span class="${getRequestStatusClass(request.status)}">${getRequestStatusLabel(request.status)}</span></td>
      <td>
        <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-request-delete="${escapeHtml(request.id)}">
          Удалить
        </button>
      </td>
    </tr>
  `).join("");
}

function deleteSiteRequest(id) {
  const store = window.NMSiteRequests;
  if (!store) return;

  const request = store.getRequests().find((item) => item.id === id);
  if (!request) return;

  const confirmed = window.confirm(`Удалить заявку от «${request.name}»?`); // eslint-disable-line no-alert
  if (!confirmed) return;

  store.deleteRequest(id);
  renderRequestsTable();
}

function renderEmployeesTable() {
  if (!employeesTable) return;

  const allEmployees = getEmployees();
  const employees = filterEmployees(allEmployees);
  updateSearchClearVisibility();
  updateEmployeesCount(employees.length, allEmployees.length);

  if (!employees.length) {
    const emptyText = getEmployeesSearchQuery() || employeesStatusFilter !== "all"
      ? "По вашему запросу ничего не найдено"
      : "Сотрудники пока не добавлены";

    employeesTable.innerHTML = `
      <tr>
        <td colspan="5">${emptyText}</td>
      </tr>
    `;
    return;
  }

  employeesTable.innerHTML = employees
    .map(
      (employee) => `
      <tr>
        <td>${escapeHtml(employee.name)}</td>
        <td>${escapeHtml(employee.role)}</td>
        <td>${renderPermissionChips(employee)}</td>
        <td>${getStatusBadge(employee.status)}</td>
        <td>
          <button class="admin-panel__action-btn" type="button" data-employee-view="${escapeHtml(employee.id)}">
            Подробнее
          </button>
        </td>
      </tr>
    `,
    )
    .join("");
}

function clearEmployeeFormErrors() {
  document.querySelectorAll("[data-employee-field]").forEach((field) => {
    field.classList.remove("has-error");
    const error = field.querySelector("[data-employee-error]");
    if (error) {
      error.hidden = true;
    }
  });
}

function showEmployeeFieldError(name, message) {
  const field = document.querySelector(`[data-employee-field="${name}"]`);
  if (!field) return;
  field.classList.add("has-error");
  const error = field.querySelector("[data-employee-error]");
  if (error) {
    error.textContent = message;
    error.hidden = false;
  }
}

function openEmployeeModal(modal) {
  if (!modal) return;
  const node = modal;
  node.hidden = false;
  document.body.classList.add("is-admin-modal-open");
}

function closeEmployeeModals() {
  if (employeeFormModal) employeeFormModal.hidden = true;
  if (employeeDetailsModal) employeeDetailsModal.hidden = true;
  document.body.classList.remove("is-admin-modal-open");
  editingEmployeeId = null;
  detailsEmployeeId = null;
  if (employeeForm) employeeForm.reset();
  clearEmployeeFormErrors();
}

function fillEmployeeForm(employee) {
  if (!employeeForm) return;
  employeeForm.elements.id.value = employee?.id || "";
  employeeForm.elements.name.value = employee?.name || "";
  employeeForm.elements.login.value = employee?.login || "";
  employeeForm.elements.role.value = employee?.role || "";
  employeeForm.elements.status.value = employee?.status || "active";
  employeeForm.elements.email.value = employee?.email || "";
  employeeForm.elements.phone.value = employee?.phone || "";
  employeeForm.elements.department.value = employee?.department || "";
  employeeForm.elements.note.value = employee?.note || "";
  renderEmployeePermissionsForm(employee?.permissions || ["dashboard"]);
}

function openCreateEmployee() {
  editingEmployeeId = null;
  if (employeeFormTitle) employeeFormTitle.textContent = "Новый сотрудник";
  fillEmployeeForm({
    status: "active",
    permissions: ["dashboard"],
  });
  clearEmployeeFormErrors();
  openEmployeeModal(employeeFormModal);
}

function openEditEmployee(id) {
  const employee = getEmployees().find((item) => item.id === id);
  if (!employee) return;

  editingEmployeeId = id;
  if (employeeFormTitle) employeeFormTitle.textContent = "Редактирование сотрудника";
  fillEmployeeForm(employee);
  clearEmployeeFormErrors();
  openEmployeeModal(employeeFormModal);
}

function openEmployeeDetails(id) {
  const employee = getEmployees().find((item) => item.id === id);
  if (!employee || !employeeDetails) return;

  detailsEmployeeId = id;
  employeeDetails.innerHTML = `
    <ul class="admin-panel__list">
      <li><span>Имя</span><strong>${escapeHtml(employee.name)}</strong></li>
      <li><span>Логин</span><strong>${escapeHtml(employee.login)}</strong></li>
      <li><span>Роль</span><strong>${escapeHtml(employee.role)}</strong></li>
      <li><span>Статус</span><strong>${STATUS_LABELS[employee.status] || escapeHtml(employee.status)}</strong></li>
      <li><span>Email</span><strong>${escapeHtml(employee.email || "—")}</strong></li>
      <li><span>Телефон</span><strong>${escapeHtml(employee.phone || "—")}</strong></li>
      <li><span>Отдел</span><strong>${escapeHtml(employee.department || "—")}</strong></li>
      <li><span>Комментарий</span><strong>${escapeHtml(employee.note || "—")}</strong></li>
      <li class="admin-panel__list-permissions">
        <span>Права доступа</span>
        <div>${renderPermissionChips(employee)}</div>
      </li>
    </ul>
  `;
  openEmployeeModal(employeeDetailsModal);
}

function deleteEmployee(id) {
  const employees = getEmployees();
  const employee = employees.find((item) => item.id === id);
  if (!employee) return;

  const confirmed = window.confirm(`Удалить сотрудника «${employee.name}»?`); // eslint-disable-line no-alert
  if (!confirmed) return;

  saveEmployees(employees.filter((item) => item.id !== id));
  closeEmployeeModals();
  renderEmployeesTable();
  renderCurrentUserProfile();
}

function handleEmployeeFormSubmit(event) {
  event.preventDefault();
  clearEmployeeFormErrors();

  const formData = new FormData(employeeForm);
  const password = String(formData.get("password") || "");
  const payload = {
    id: String(formData.get("id") || ""),
    name: String(formData.get("name") || "").trim(),
    login: String(formData.get("login") || "").trim(),
    role: String(formData.get("role") || "").trim(),
    status: String(formData.get("status") || "active"),
    email: String(formData.get("email") || "").trim(),
    phone: String(formData.get("phone") || "").trim(),
    department: String(formData.get("department") || "").trim(),
    note: String(formData.get("note") || "").trim(),
    permissions: normalizePermissions(getSelectedEmployeePermissions()),
  };
  if (password) payload.password = password;

  let hasError = false;

  if (!payload.name) {
    showEmployeeFieldError("name", "Введите имя");
    hasError = true;
  }

  if (!payload.login) {
    showEmployeeFieldError("login", "Введите логин");
    hasError = true;
  }

  if (!payload.role) {
    showEmployeeFieldError("role", "Введите роль");
    hasError = true;
  }

  if (!editingEmployeeId && password.length < 4) {
    showEmployeeFieldError("password", "Укажите пароль не короче 4 символов");
    hasError = true;
  } else if (editingEmployeeId && password && password.length < 4) {
    showEmployeeFieldError("password", "Пароль не короче 4 символов");
    hasError = true;
  }

  if (hasError) return;

  const employees = getEmployees();
  const duplicate = employees.find(
    (item) => item.login.toLowerCase() === payload.login.toLowerCase() && item.id !== editingEmployeeId,
  );

  if (duplicate) {
    showEmployeeFieldError("login", "Такой логин уже существует");
    return;
  }

  if (editingEmployeeId) {
    const nextEmployees = employees.map((item) =>
      (item.id === editingEmployeeId ? { ...item, ...payload, id: editingEmployeeId } : item),
    );
    saveEmployees(nextEmployees);

    const currentLogin = String(sessionStorage.getItem(AUTH_USER) || "").toLowerCase();
    const previous = employees.find((item) => item.id === editingEmployeeId);
    if (previous && String(previous.login || "").toLowerCase() === currentLogin) {
      sessionStorage.setItem(AUTH_USER, payload.login);
    }
  } else {
    saveEmployees([
      ...employees,
      {
        ...payload,
        id: String(Date.now()),
      },
    ]);
  }

  closeEmployeeModals();
  renderEmployeesTable();
  renderCurrentUserProfile();
  applyNavigationPermissions();
}

if (form) {
  form.addEventListener("submit", handleSubmit);
}

if (profileAccountForm) {
  let profileCanceling = false;

  profileAccountForm.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-profile-edit]");
    if (editBtn) {
      openProfileRow(editBtn.getAttribute("data-profile-edit"));
      return;
    }

    const cancelBtn = event.target.closest("[data-profile-cancel-field]");
    if (cancelBtn) {
      profileCanceling = true;
      closeAllProfileRows();
      renderCurrentUserProfile();
      window.setTimeout(() => {
        profileCanceling = false;
      }, 0);
    }
  });

  profileAccountForm.addEventListener("keydown", (event) => {
    const row = event.target.closest("[data-profile-row]");
    if (!row || !row.classList.contains("is-editing")) return;

    if (event.key === "Enter") {
      event.preventDefault();
      saveProfileField(row.getAttribute("data-profile-row"));
    }

    if (event.key === "Escape") {
      event.preventDefault();
      profileCanceling = true;
      closeAllProfileRows();
      renderCurrentUserProfile();
      window.setTimeout(() => {
        profileCanceling = false;
      }, 0);
    }
  });

  profileAccountForm.addEventListener("focusout", (event) => {
    if (profileCanceling) return;

    const row = event.target.closest("[data-profile-row]");
    if (!row || !row.classList.contains("is-editing")) return;

    const next = event.relatedTarget;
    if (next && row.contains(next)) return;

    saveProfileField(row.getAttribute("data-profile-row"));
  });

  profileAccountForm.querySelectorAll("input").forEach((input) => {
    input.addEventListener("input", () => {
      const row = input.closest("[data-profile-row]");
      clearProfileRowError(row);
      if (profileAccountNote) profileAccountNote.hidden = true;
    });
  });
}

logoutButtons.forEach((button) => {
  button.addEventListener("click", handleLogout);
});

if (userToggle) {
  userToggle.addEventListener("click", (event) => {
    event.stopPropagation();
    toggleUserMenu();
  });
}

if (sidebarToggle) {
  sidebarToggle.addEventListener("click", (event) => {
    event.stopPropagation();
    toggleAdminSidebar();
  });
}

if (sidebarOverlay) {
  sidebarOverlay.addEventListener("click", closeAdminSidebar);
}

navLinks.forEach((link) => {
  link.addEventListener("click", handleAdminLinkClick);
});

if (createEmployeeBtn) {
  createEmployeeBtn.addEventListener("click", openCreateEmployee);
}

if (employeeForm) {
  employeeForm.addEventListener("submit", handleEmployeeFormSubmit);
}

if (employeePermissionsAll) {
  employeePermissionsAll.addEventListener("change", syncEmployeePermissionsDisabledState);
}

if (editFromDetailsBtn) {
  editFromDetailsBtn.addEventListener("click", () => {
    if (!detailsEmployeeId) return;
    const id = detailsEmployeeId;
    closeEmployeeModals();
    openEditEmployee(id);
  });
}

if (deleteFromDetailsBtn) {
  deleteFromDetailsBtn.addEventListener("click", () => {
    if (!detailsEmployeeId) return;
    deleteEmployee(detailsEmployeeId);
  });
}

if (employeesSearch) {
  employeesSearch.addEventListener("input", () => {
    renderEmployeesTable();
  });
}

if (employeesSearchClear) {
  employeesSearchClear.addEventListener("click", () => {
    if (!employeesSearch) return;
    employeesSearch.value = "";
    employeesSearch.focus();
    renderEmployeesTable();
  });
}

employeesFilters.forEach((button) => {
  button.addEventListener("click", () => {
    employeesStatusFilter = button.getAttribute("data-employees-filter") || "all";
    employeesFilters.forEach((item) => {
      item.classList.toggle("is-active", item === button);
    });
    renderEmployeesTable();
  });
});

document.querySelectorAll("[data-employee-modal-close]").forEach((element) => {
  element.addEventListener("click", closeEmployeeModals);
});

if (employeesTable) {
  employeesTable.addEventListener("click", (event) => {
    const target = event.target.closest("[data-employee-view]");
    if (!target) return;

    const viewId = target.getAttribute("data-employee-view");
    if (viewId) openEmployeeDetails(viewId);
  });
}

const requestsTable = document.querySelector("[data-requests-table]");
if (requestsTable) {
  requestsTable.addEventListener("click", (event) => {
    const target = event.target.closest("[data-request-delete]");
    if (!target) return;

    const requestId = target.getAttribute("data-request-delete");
    if (requestId) deleteSiteRequest(requestId);
  });
}

document.addEventListener("click", (event) => {
  if (!userRoot || !userMenu || userMenu.hidden) return;
  if (!userRoot.contains(event.target)) {
    closeUserMenu();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeUserMenu();
    closeAdminSidebar();
    closeEmployeeModals();
  }
});

window.addEventListener("resize", () => {
  if (!isMobileAdminLayout()) closeAdminSidebar();
});

window.addEventListener("popstate", () => {
  if (!adminRoot) return;

  if (!isAuthenticated()) {
    showStage(loginStage);
    return;
  }

  showStage(panelStage);
  showView(getRouteFromPath());
});

if (adminRoot) {
  const initialRoute = getRouteFromPath();
  const startAdmin = (authenticated) => {
    if (authenticated) {
      renderEmployeesTable();
      renderRequestsTable();
      renderCurrentUserProfile();
      openPanel(initialRoute);
    } else {
      if (initialRoute !== "dashboard") {
        rememberRedirect(initialRoute);
        window.history.replaceState({}, "", ROUTES.dashboard);
      }
      showStage(loginStage);
    }
    window.NMApi?.revealPage?.();
  };

  const api = window.NMApi;
  if (api?.ready) {
    api.ready.then(() => api.me()).then((user) => {
      if (user) setAuthenticated(user.login);
      startAdmin(Boolean(user));
    }).catch(() => startAdmin(false));
  } else {
    startAdmin(isAuthenticated());
  }
}
